import moment from 'moment';
import * as yup from 'yup';

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
) =>
  yup.object().shape({
    // title: yup
    //   .string()
    //   .required('タイトルは未入力です。')
    //   .max(100, 'タイトルは100文字以内で入力してください。'),
    // message: yup
    //   .string()
    //   .required('本文は未入力です。')
    //   .max(500, '本文は500文字以内で入力してください。'),
    pushNotificationDate: yup
      .date()
      .required('配信日時を選択してください。')
      .when('status', ([status], schema) => {
        if ((isActionEdit && isNotPermissionEdit) || !status) {
          return schema;
        }

        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          '配信日時が過去の日時になっています。',
        );
      }),
    // type: yup.string().required('種類は未入力です。'),
    status: yup
      .boolean()
      .required('ステータスは未入力です。')
      .oneOf([true, false], 'ステータスは未入力です。'),
  } as any);
